import { render, staticRenderFns } from "./CreateFaq.vue?vue&type=template&id=356bc27a&"
import script from "./CreateFaq.vue?vue&type=script&lang=js&"
export * from "./CreateFaq.vue?vue&type=script&lang=js&"
import style0 from "./CreateFaq.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports